<header>
  <!-- DESKTOP MENU -->
  <nav class="navbar navbar-expand-md navbar-dark-pepsico fixed-top d-none d-lg-block">
    <div class="container-fluid">
      <a class="navbar-brand" routerLink="home">
        <img src="./assets/images/logo-app.png" class="logo-shop discard-nav-bar">
      </a>
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav me-auto mb-2 mb-md-0 dicard-menu-less">
          @for (item of principalMenuItems; track item.path) {
          <li class="nav-item">
            <a class="nav-link white btn-hover-pepsico fnt-12" [routerLink]="item.path" routerLinkActive="on-site">
              {{ item.title }}
            </a>
          </li>
          }
        </ul>
        <form class="d-flex" role="search">
          <ul class="navbar-nav me-auto mb-2 mb-md-0">
            <!-- PERFIL -->
            <li class="nav-item dropdown show">
              <div class="hover-label-wrapper">
                <a class="nav-link white btn-hover-pepsico fnt-12" routerLink="profile" role="button">
                  <img [src]="holidayDataService.holidaysData()[HolidayTypes.Profile]" width="25">
                </a>
                <div class="hover-label">Perfil</div>
              </div>
            </li>

            <!-- INCOGNITO-->
            @if(userDataService.userData()?.profile == 'STAFF'){
            <li class="nav-item dropdown show">
              <div class="hover-label-wrapper">
                <a class="nav-link white btn-hover-pepsico fnt-12" routerLink="incognito" role="button">
                  <img src="./assets/images/pepsico-icons-menu6.png" alt="" width="25">
                </a>
                <div class="hover-label">Usuario incógnito</div>
              </div>
            </li>
            }
            <!-- CARRITO -->
            <li class="nav-item dropdown show">
              <div class="hover-label-wrapper">
                <cart-nav />
              </div>
            </li>

            <!-- NOTIFICACIONES -->
            <li class="nav-item dropdown show">
              <div class="hover-label-wrapper">
                <notifications-nav />
              </div>
            </li>

            <!-- WISHLIST -->
            <li class="nav-item dropdown show">
              <div class="hover-label-wrapper">
                <wish-list-nav />
              </div>
            </li>

            <!-- SALIR -->
            <li class="nav-item">
              <div class="hover-label-wrapper">
                <a class="nav-link white btn-hover-pepsico fnt-12" href="javascript:void(0)" (click)="logOut()"
                  role="button">
                  <img src="./assets/images/pepsico-icons-menu5.png" width="25">
                </a>
                <div class="hover-label">Salir</div>
              </div>
            </li>
          </ul>
        </form>
      </div>
    </div>
  </nav>
  <!-- DESKTOP MENU END -->

  <!-- MOBILE MENU -->
  <nav class="py-2 bg-body-tertiary border-bottom navbar-dark-pepsico d-lg-none brd-menumob">
    <div class="container d-flex flex-wrap hgt-35">
      <ul class="nav pt-mobile-absolute">
        <!--PERFIL-->
        <li class="nav-item">
          <a class="nav-link white btn-hover-pepsico fnt-12 pd-5-d" routerLink="profile" role="button">
            <img [src]="holidayDataService.holidaysData()[HolidayTypes.Profile]" width="25">
          </a>
        </li>

        <!--CARRITO-->
        <li class="nav-item dropdown show">
          <cart-nav isMobile />
        </li>

        <!--NOTIFICACIONES-->
        <!-- <li class="nav-item dropdown show">
          <a class="nav-link dropdown-toggle white btn-hover-pepsico fnt-13 pd-5-d" href="#" role="button"
            id="dropdownMenuLink" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <img src="./assets/images/pepsico-icons-menu3.png" width="25">
            <span class="icon-button__badge"></span>
          </a>
          <div class="dropdown-menu notificationBox notificationBox___mobile_notificaciones"
            aria-labelledby="dropdownMenuLink">
            <div class="notificationTriangle-notificaciones-mobile is-active"></div>
            <div class="notificationHeader">
              <div class="notificationHeader--title">
                Avisos Importantes
              </div>
              <div class="notificationHeader--unread">
                <div>5 Nuevos </div>
              </div>
            </div>
            <div>
              <div class="notificationList">
                <div>
                  @for (item of [1, 1, 1, 1]; track $index) {
                  <div class="notification">
                    <a tabindex="0" routerLink="notifications">
                      <div class="notification--subHeader">
                        <div class="notification--subHeader--title">
                          Aviso importante 1
                        </div>
                        <div class="notification--subHeader--hour">
                          <span>Dic 27</span>
                        </div>
                      </div>
                      <div class="notification--description">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta, alias aliquam magni atque
                        facilis dicta.
                      </div>
                    </a>
                  </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </li> -->

        <!--WISHLIST-->
        <li class="nav-item dropdown show">
          <wish-list-nav isMobile />
        </li>
      </ul>
    </div>
  </nav>

  <nav class="navbar navbar-dark navbar-dark-pepsico d-lg-none classs-levl">
    <div class="container-fluid">
      <a class="navbar-brand" routerLink="home">
        <img src="./assets/images/logo-mobile.png" width="100px">
      </a>
      <button class="navbar-toggler collapsed" type="button" data-bs-toggle="collapse"
        data-bs-target="#navbarsExample01" aria-controls="navbarsExample01" aria-expanded="false"
        aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="navbar-collapse collapse text-center" id="navbarsExample01">
        <ul class="navbar-nav me-auto mb-2 mg-tp-t1">
          @for (item of principalMenuItems; track item.path) {
          <li class="nav-item">
            <a class="nav-link white btn-hover-pepsico mobile-letter-action on-site" [routerLink]="item.path"
              routerLinkActive="on-site">
              {{ item.title }}
            </a>
          </li>
          }
          <li class="nav-item">
            <a class="nav-link white btn-hover-pepsico mobile-letter-action" aria-disabled="true"
              href="javascript:void(0)" (click)="logOut()">Salir</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <!-- MOBILE MENU END -->
</header>